const EDIT_APP_PARTNER_DRAFT_PREFIX = 'admin:appPartnerDraft:edit:'
export const NEW_APP_PARTNER_DRAFT_KEY = 'admin:appPartnerDraft:new'
export const APP_PARTNER_IMAGE_FILE_ACCEPT = '.jpg,.jpeg,.png,.gif,.webp,image/png,image/gif,image/jpeg,image/webp'
export const APP_PARTNER_IMAGE_FILE_ERROR_MESSAGE = '이미지 파일만 업로드할 수 있습니다.'

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizeTextValue = (value) => {
    if (value === undefined || value === null) {
        return ''
    }

    return String(value)
}

const normalizeNumberValue = (value, fallbackValue = 0) => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

// 제휴사 로고 업로드에서 허용하는 이미지 형식만 통과시킨다.
export const isAppPartnerImageFile = (file) => {
    return Boolean(file) && (
        (file.type && file.type.startsWith('image/')) ||
        /\.(jpg|jpeg|png|gif|webp)$/i.test(file.name || '')
    )
}

// 제휴사 폼은 이미지 파일을 제외한 텍스트와 본인인증여부만 sessionStorage에 남긴다.
export const createAppPartnerDraftPayload = ({ params = {} } = {}) => {
    return {
        params: {
            partnerName: normalizeTextValue(params.partnerName),
            title: normalizeTextValue(params.title),
            content: normalizeTextValue(params.content),
            isIdentity: normalizeNumberValue(params.isIdentity, 1),
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 작성 흐름을 이어간다.
export const applyAppPartnerDraft = ({ baseParams = {}, draft }) => {
    const normalizedBaseDraft = createAppPartnerDraftPayload({
        params: baseParams,
    })

    if (!draft) {
        return {
            params: {
                ...baseParams,
                ...normalizedBaseDraft.params,
            },
        }
    }

    const draftParams = draft.params || {}

    return {
        params: {
            ...baseParams,
            partnerName: draftParams.partnerName === undefined
                ? normalizedBaseDraft.params.partnerName
                : normalizeTextValue(draftParams.partnerName),
            title: draftParams.title === undefined
                ? normalizedBaseDraft.params.title
                : normalizeTextValue(draftParams.title),
            content: draftParams.content === undefined
                ? normalizedBaseDraft.params.content
                : normalizeTextValue(draftParams.content),
            isIdentity: draftParams.isIdentity === undefined
                ? normalizedBaseDraft.params.isIdentity
                : normalizeNumberValue(draftParams.isIdentity, normalizedBaseDraft.params.isIdentity),
        }
    }
}

export const createEditAppPartnerDraftKey = (partnerId) => `${EDIT_APP_PARTNER_DRAFT_PREFIX}${partnerId}`

export const readAppPartnerDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAppPartnerDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 작성 흐름은 그대로 유지한다.
    }
}

export const clearAppPartnerDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
